import type { ChainConfig } from '../types/config.js'

// Official Safe-supported chains from https://safe-client.safe.global/v1/chains
// ShortNames follow EIP-3770 standard from https://github.com/ethereum-lists/chains
export const DEFAULT_CHAINS: Record<string, ChainConfig> = {
  '1': {
    name: 'Ethereum',
    chainId: '1',
    shortName: 'eth',
    rpcUrl: 'https://eth.drpc.org',
    explorer: 'https://etherscan.io',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-mainnet.safe.global',
  },
  '11155111': {
    name: 'Sepolia',
    chainId: '11155111',
    shortName: 'sep',
    rpcUrl: 'https://0xrpc.io/sep',
    explorer: 'https://sepolia.etherscan.io',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-sepolia.safe.global',
  },
  '100': {
    name: 'Gnosis Chain',
    chainId: '100',
    shortName: 'gno',
    rpcUrl: 'https://rpc.gnosischain.com',
    explorer: 'https://gnosisscan.io',
    currency: 'XDAI',
    transactionServiceUrl: 'https://safe-transaction-gnosis-chain.safe.global',
  },
  '137': {
    name: 'Polygon',
    chainId: '137',
    shortName: 'matic',
    rpcUrl: 'https://polygon-rpc.com',
    explorer: 'https://polygonscan.com',
    currency: 'POL',
    transactionServiceUrl: 'https://safe-transaction-polygon.safe.global',
  },
  '42161': {
    name: 'Arbitrum',
    chainId: '42161',
    shortName: 'arb1',
    rpcUrl: 'https://arb1.arbitrum.io/rpc',
    explorer: 'https://arbiscan.io',
    currency: 'AETH',
    transactionServiceUrl: 'https://safe-transaction-arbitrum.safe.global',
  },
  '10': {
    name: 'Optimism',
    chainId: '10',
    shortName: 'oeth',
    rpcUrl: 'https://mainnet.optimism.io',
    explorer: 'https://optimistic.etherscan.io',
    currency: 'OETH',
    transactionServiceUrl: 'https://safe-transaction-optimism.safe.global',
  },
  '8453': {
    name: 'Base',
    chainId: '8453',
    shortName: 'base',
    rpcUrl: 'https://mainnet.base.org',
    explorer: 'https://basescan.org',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-base.safe.global',
  },
  '56': {
    name: 'BNB Chain',
    chainId: '56',
    shortName: 'bnb',
    rpcUrl: 'https://bsc.drpc.org',
    explorer: 'https://bscscan.com',
    currency: 'BNB',
    transactionServiceUrl: 'https://safe-transaction-bsc.safe.global',
  },
  '43114': {
    name: 'Avalanche',
    chainId: '43114',
    shortName: 'avax',
    rpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
    explorer: 'https://snowtrace.io',
    currency: 'AVAX',
    transactionServiceUrl: 'https://safe-transaction-avalanche.safe.global',
  },
  '59144': {
    name: 'Linea',
    chainId: '59144',
    shortName: 'linea',
    rpcUrl: 'https://rpc.linea.build',
    explorer: 'https://lineascan.build',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-linea.safe.global',
  },
  '324': {
    name: 'zkSync Era',
    chainId: '324',
    shortName: 'zksync',
    rpcUrl: 'https://mainnet.era.zksync.io',
    explorer: 'https://explorer.zksync.io',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-zksync.safe.global',
  },
  '1101': {
    name: 'Polygon zkEVM',
    chainId: '1101',
    shortName: 'zkevm',
    rpcUrl: 'https://zkevm-rpc.com',
    explorer: 'https://zkevm.polygonscan.com',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-zkevm.safe.global',
  },
  '534352': {
    name: 'Scroll',
    chainId: '534352',
    shortName: 'scr',
    rpcUrl: 'https://rpc.scroll.io',
    explorer: 'https://scrollscan.com',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-scroll.safe.global',
  },
  '42220': {
    name: 'Celo',
    chainId: '42220',
    shortName: 'celo',
    rpcUrl: 'https://rpc.ankr.com/celo',
    explorer: 'https://explorer.celo.org/mainnet',
    currency: 'CELO',
    transactionServiceUrl: 'https://safe-transaction-celo.safe.global',
  },
  '5000': {
    name: 'Mantle',
    chainId: '5000',
    shortName: 'mnt',
    rpcUrl: 'https://rpc.mantle.xyz',
    explorer: 'https://mantlescan.xyz',
    currency: 'MNT',
    transactionServiceUrl: 'https://safe-transaction-mantle.safe.global',
  },
  '1313161554': {
    name: 'Aurora',
    chainId: '1313161554',
    shortName: 'aurora',
    rpcUrl: 'https://mainnet.aurora.dev',
    explorer: 'https://aurorascan.dev',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-aurora.safe.global',
  },
  '480': {
    name: 'World Chain',
    chainId: '480',
    shortName: 'wc',
    rpcUrl: 'https://worldchain-mainnet.g.alchemy.com/public',
    explorer: 'https://worldchain-mainnet.explorer.alchemy.com',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-worldchain.safe.global',
  },
  '146': {
    name: 'Sonic',
    chainId: '146',
    shortName: 'sonic',
    rpcUrl: 'https://rpc.soniclabs.com',
    explorer: 'https://sonicscan.org',
    currency: 'S',
    transactionServiceUrl: 'https://safe-transaction-sonic.safe.global',
  },
  '130': {
    name: 'Unichain',
    chainId: '130',
    shortName: 'unichain',
    rpcUrl: 'https://mainnet.unichain.org',
    explorer: 'https://uniscan.xyz',
    currency: 'ETH',
    transactionServiceUrl: 'https://safe-transaction-unichain.safe.global',
  },
}
